import {TextStyle, ViewStyle} from 'react-native';
import BaseDescriptor from './redemptionDetail-default';

export function redemptionDetailStyle(): {
  container: ViewStyle;
  date: ViewStyle | TextStyle;
  content: ViewStyle;
  dashStyle: ViewStyle;
  location: TextStyle;
  row: ViewStyle;
  textLabel: ViewStyle;
  trans: TextStyle;
  largeLabel: TextStyle;
  total: ViewStyle | TextStyle;
} {
  const defaultStyle = BaseDescriptor.redemptionDetailStyle();
  return {
    ...defaultStyle,
    container: {
      ...defaultStyle.container,
      backgroundColor: 'transparent',
    },
  };
}

export default {
  redemptionDetailStyle,
};
